/**
 * @file User address update/create display.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import UserAddressDisplayEditBox from './UserAddressDisplayEditBox';
import UserAddressFormModal from './UserAddressFormModal';
import Spinner from '../Spinner';
import Angle from '../Angle';

class UserAddressCreateUpdate extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    userId: PropTypes.string,
    address: PropTypes.object,
    createAccountAddress: PropTypes.func.isRequired,
    updateAccountAddress: PropTypes.func.isRequired,
    className: PropTypes.string,
    addressDisplayTitle: PropTypes.string,
    onSuccess: PropTypes.func,
    onAddressCreated: PropTypes.func,
    onAddressUpdated: PropTypes.func,
  };

  static defaultProps = {
    onSuccess: () => {},
  };

  state = {
    edit: false,
  };

  onAddressEdit = event => {
    event?.preventDefault?.();
    this.setState(() => ({ edit: true }));
  };

  onAddressEditDismiss = () => {
    this.setState(() => ({ edit: false }));
  };

  render() {
    const { edit } = this.state;
    const {
      loading,
      address,
      className,
      addressDisplayTitle,
      userId,
      createAccountAddress,
      updateAccountAddress,
      onSuccess,
      onAddressCreated,
      onAddressUpdated,
    } = this.props;
    const classes = classNames({ [className]: !!className });

    if (loading || !userId) {
      return (
        <div className="text-center p-1">
          <Spinner size="sm" />
        </div>
      );
    }

    return (
      <div className={classes}>
        {address ? (
          <UserAddressDisplayEditBox
            address={address}
            onClick={this.onAddressEdit}
            title={addressDisplayTitle}
          />
        ) : (
          <a className="user-address-add" onClick={this.onAddressEdit} href="#">
            <p className="m-0">
              Add shipping address <strong>(required)</strong>
            </p>
            <Angle direction="right" />
          </a>
        )}

        <UserAddressFormModal
          address={address}
          userId={userId}
          updateAccountAddress={updateAccountAddress}
          createAccountAddress={createAccountAddress}
          forceOpen={edit}
          onCancel={this.onAddressEditDismiss}
          onSuccess={(...args) => {
            onSuccess(...args);
            this.onAddressEditDismiss(...args);
          }}
          onAddressCreated={onAddressCreated}
          onAddressUpdated={onAddressUpdated}
        />
      </div>
    );
  }
}

export default UserAddressCreateUpdate;
